import omitBy from 'lodash/omitBy'
import pickBy from 'lodash/pickBy'

/**
 * Возвращает фильтры для атрибутов для удобной работы в шаблонах
 * Breaking changes: https://v3-migration.vuejs.org/breaking-changes/attrs-includes-class-style.html
 */

/** Проверка, явлется ли атрибут listener */
const isListener = (value, key) =>
  typeof value === 'function' && key.startsWith('on')

/** Проверка, явлется ли атрибут class или style */
const isClassOrStyle = (value, key) => ['class', 'style'].includes(key)

/**
 * Возвращает аналог vue2 $listeners
 * @param {object} $attrs исходные атрибуты компонента
 */
export const getListeners = ($attrs) => pickBy($attrs, isListener)

/**
 * Возвращает все атрибуты (с классами и стилями)
 * @param {object} $attrs исходные атрибуты компонента
 */
export const getAttrsAll = ($attrs) => omitBy($attrs, isListener)

/**
 * Возвращает атрибуты без классов, стилей, listeners - аналог vue2 $attrs
 * @param {object} $attrs исходные атрибуты компонента
 */
export const getAttrs = ($attrs) =>
  omitBy(
    $attrs,
    (value, key) => isListener(value, key) || isClassOrStyle(value, key),
  )

/**
 * Возвращает корневые атрибуты, которые автоматически наследовались во vue
 * @param {object} $attrs исходные атрибуты компонента
 */
export const getClassAndStyle = ($attrs) => pickBy($attrs, isClassOrStyle)
